export default "__VITE_ASSET__BmfO4zIb__"